<template>
    <div class="flight-panel" v-show="visible">
        <!-- 最近搜索 -->
        <div class="hot-body">
            <div class="panel-title">
                <span>
                    <i class="iconfont icon-collection"></i>
                    {{$t('recent_search')}}
                </span>
                <span @click="clearRecord" class="hover-class">{{$t('clear_record')}}</span>
            </div>
            <div class="flex-row-wrap">
                <div
                    class="city-tag"
                    v-for="(item, i) in flightSearchHistory"
                    :key="i"
                    @click="select(item)"
                >{{item.city_name}}</div>
            </div>
        </div>

        <!-- 推荐 -->
        <div class="hot-body" v-if="flightHotCitys && flightHotCitys.length > 0">
            <div>
                <i class="iconfont icon-recommend"></i>
                {{$t('hot_rec')}}
            </div>
            <ul class="flight-country-list">
                <li
                    class="list-item"
                    v-for="item in flightHotCitys"
                    :key="item.city_code"
                    @click.stop="select(item)"
                >
                    <img class="na-flag" :src="item.national_flag" />
                    <span class="city-text">{{item.city_name}}, {{item.country_name}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(["flightHotCitys", "flightSearchHistory"])
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        /**
         * 清除历史记录
         */
        clearRecord() {
            this.$store.dispatch("setSearchHistory", []);
        },

        /**
         * 选择一项记录
         * @param {*} item 当前城市/区域的数据
         */
        select(item) {
            this.$store.dispatch("setSearchHistory", item);
            this.$emit("update:visible", false);
            this.$emit("select", item.city_name, item.city_code);
        }
    }
};
</script>

<style lang="scss" scoped>
.flight-panel {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 2048;
    width: 390px;
    font-size: 14px;
    color: #484848;
    background-color: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16),
        0px 2px 5px 0px rgba(0, 0, 0, 0.26);

    .hot-body {
        box-sizing: border-box;
        padding: 10px 16px 15px;
        &:first-child {
            border-bottom: 1px solid #eee;
        }

        .icon-recommend {
            margin-right: 5px;
        }
    }

    .panel-title {
        display: flex;
        justify-content: space-between;
        .icon-collection {
            vertical-align: middle;
        }
    }

    .flight-country-list {
        .list-item {
            margin-top: 15px;
            cursor: pointer;
            transition: all ease-in-out 0.3s;
            &:hover {
                text-decoration: underline;
            }

            .na-flag {
                width: 18px;
                vertical-align: middle;
                margin-right: 8px;
            }

            .city-text {
                vertical-align: middle;
            }
        }
    }

    .flex-row-wrap {
        display: flex;
        // justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .city-text {
            display: inline-block;
            color: #484848;
            margin-right: 20px;
            margin-top: 10px;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }

        .city-tag {
            max-width: 100px;
            box-sizing: border-box;
            background-color: #49beb7;
            color: #fff;
            padding: 3px;
            margin-right: 10px;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
        }
    }

    .hover-class {
        cursor: pointer;
        vertical-align: middle;
        &:hover {
            opacity: 0.7;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Public/components/FlightSearchPanel.vue